import { processText } from '@/shared/libs/process-text';

interface GamePathSource {
  providerId?: string;
  title?: string;
  code?: string;
}

export function getGamePath(game?: GamePathSource | null): string {
  return `/games/${processText(game?.providerId)}/${game?.code || processText(game?.title)}`;
}
